
import { defineComponent, reactive, toRefs } from 'vue';

export default defineComponent({
    /*別場面に遷移するボタン*/
    name: 'ArrowLink',
    props: {
        url: {
            type: String,
        },
        action: {
            type: Function,
            default: undefined,
        },
        isArrowWhite: {
            type: Boolean,
            default: false,
        },
        isArrowDeepBlue: {
            type: Boolean,
            default: true,
        },
        isArrowSmallBlue: {
            type: Boolean,
            default: false,
        },
        fontSize: {
            type: Number,
            default: 14,
        },
        arrowType: {
            type: String,
            default: 'blue',
        },
        isExternal: {
            type: Boolean,
            default: false,
        },
        isBlueBorder: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const state = reactive({
            test: '_blank',
        });
        const onClick = (e: Event) => {
            if (props.action != null) {
                props.action();
                e.preventDefault();
            }
        };
        return {
            ...toRefs(state),
            onClick,
        };
    },
});
